/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import {
	ISchemaActionRefModel,
	isSchemaActionRefModel,
	TGenericModelNode
} from "@adapptio/lib-blueprint";
import { INSPECTOR_NODE_TYPE, TInspectorNode } from "../InspectorNodeTypes";
import { mapModelToNodes } from "../index";
import { mapperDescriptor } from "../../modules/Core/ReferenceGuide/mappers/mapperDescriptor";
import { mapperExamples } from "../../modules/Core/ReferenceGuide/mappers/mapperExamples";
import { getParentComponentName } from "../utils";

export function actionRefMapper(model: ISchemaActionRefModel): TInspectorNode {
	if (!isSchemaActionRefModel(model)) {
		return;
	}

	const deps: TGenericModelNode[] = [ model, model.params, model.actionId ];
	const controls = [];

	const actionIdNode = mapModelToNodes(model.actionId);

	if (actionIdNode) {
		deps.push(...actionIdNode.deps);
		controls.push(...actionIdNode.controls);
	}

	if (model.params) {
		deps.push(model.params);
	}

	if (model.params?.value) {
		deps.push(model.params.value);
	}

	return {
		type: INSPECTOR_NODE_TYPE.DEFAULT,
		key: `${model.nodeId}`,
		label: "",
		tooltip: "",
		deps: deps,
		controls: [],
		children: [
			() => {
				return {
					type: INSPECTOR_NODE_TYPE.DEFAULT,
					key: `${model.nodeId}`,
					label: model.schema.opts.label,
					tooltip: model.schema.opts.description,
					default: model.schema.opts["default"] || null,
					required: model.schema.opts.constraints?.required || false,
					options: model.schema.opts["options"],
					referenceData: getParentComponentName(model),
					descriptor: mapperDescriptor(model.schema),
					examples: mapperExamples(model.schema),
					deps: deps,
					controls: controls,
					children: []
				};
			},
			() => {
				const node = mapModelToNodes(model.params?.value);

				return node;
			}
		]
	};
}
